import Table from 'material-ui/Table/Table';
import TableBody from 'material-ui/Table/TableBody';
import TableCell from 'material-ui/Table/TableCell';
import TableHead from 'material-ui/Table/TableHead';
import TableFooter from 'material-ui/Table/TableFooter';
import TableRow from 'material-ui/Table/TableRow';
import TableSortLabel from 'material-ui/Table/TableSortLabel';
import TablePagination from 'material-ui/Table/TablePagination';

import DataTable from './DataTable';

export { TableBody, TableCell, TableHead, TableRow, TableSortLabel, TableFooter, TablePagination, DataTable };
export default Table;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Table/index.ts